import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type UserId = Branded<string, "UserId">;
const userIdPrefix = "user__";
const {
    zodSchema: userIdZodSchema,
    factory: userIdFactory,
    assert: isUserId,
} = genericId<UserId>(userIdPrefix, {
    regexMatch: /^(emanuel-lundman|david-werjefelt|jakob-boman|user_\S+)$/,
});

export { isUserId, userIdFactory, userIdPrefix, userIdZodSchema };
export type { UserId };
